export default function cleanTitle (str) {
    if (str === null || str === undefined) {
        return str;
    };
    const removeSpecialChars = ['🥇'];

    removeSpecialChars.forEach((char) => {
        str = str.replace(char, '');
    });

    return str;
}
